import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './DropDown.scss';
import { IconChevronDown, IconChevronUp } from '@tabler/icons';
export const DropDown = function DropDown({ title, isOpen, onClick }) {
    return _jsx("div", { className: 'editor-component-dropdown', children: _jsxs("div", { className: 'editor-component-dropdown-title-container', onClick: onClick, children: [_jsx("div", { className: 'editor-component-dropdown-title', children: title }), isOpen ? _jsx(IconChevronUp, { size: 24 }) : _jsx(IconChevronDown, { size: 24 })] }) });
};
